import type { CSSProperties, ElementType, ReactNode } from "react";
import { cn } from "@/lib/utils";

type Props = {
  as?: ElementType;
  x?: number;
  y?: number;
  delay?: number;
  duration?: number;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
  [key: string]: unknown;
};

/** Entrada ao rolar (fade + deslocamento), só com CSS + um observer global. */
export function Reveal({
  as: Tag = "div",
  x = 0,
  y = 0,
  delay = 0,
  duration = 0.6,
  className,
  style,
  children,
  ...rest
}: Props) {
  return (
    <Tag
      {...rest}
      className={cn("reveal", className)}
      style={
        {
          "--rx": `${x}px`,
          "--ry": `${y}px`,
          "--rd": `${delay}s`,
          "--rdur": `${duration}s`,
          ...style,
        } as CSSProperties
      }
    >
      {children}
    </Tag>
  );
}
